import { Refresh } from '@mui/icons-material';
import { CircularProgress, IconButton } from '@mui/material';
import React from 'react';

const RefreshBtn = ({ onRefresh, isFetchingData }) => {
  return (
    <IconButton
      onClick={onRefresh}
      disabled={isFetchingData}
      sx={{
        p: '4px',
      }}
    >
      {isFetchingData ? <CircularProgress size={24} /> : <Refresh />}
    </IconButton>
  );
};

export default RefreshBtn;
